import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AppHeader({ title = "Programa de Cuidados", subtitle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-gradient-to-r from-[#1E3A8A] to-[#1D4ED8] text-white shadow-md">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3 sm:py-4">
        <Link
          to="/dashboard"
          className="flex items-center gap-3"
          data-testid="header-home-link"
        >
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white p-1 shadow-sm">
            <img
              src="/assets/logo.svg"
              alt="Ciudad Enfermeria"
              className="h-full w-full object-contain"
            />
          </div>
          <div className="leading-tight">
            <div className="text-base font-bold tracking-tight sm:text-lg">
              Ciudad Enfermeria
            </div>
            <div className="text-[11px] font-medium opacity-90 sm:text-xs">
              {subtitle || title}
            </div>
          </div>
        </Link>
        {user && user !== false && (
          <div className="flex items-center gap-2">
            {user.role === "admin" && (
              <span
                className="hidden items-center gap-1 rounded-full bg-amber-300/95 px-2.5 py-1 text-[11px] font-bold text-amber-900 sm:inline-flex"
                data-testid="header-admin-badge"
              >
                <ShieldCheck className="h-3.5 w-3.5" /> Admin
              </span>
            )}
            <span className="hidden text-sm font-semibold sm:inline" data-testid="header-username">
              {user.name}
            </span>
            <Button
              variant="ghost"
              size="sm"
              className="h-9 gap-1.5 rounded-lg bg-white/10 px-3 text-white hover:bg-white/20"
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
              data-testid="header-logout-btn"
            >
              <LogOut className="h-4 w-4" />
              <span className="text-sm">Salir</span>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
